import { useCallback, useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { CategoryItem, User } from '../../interfaces';
import { getRandomBgColor } from '../../utils/others';
import UserCard from './UserCard';
import useCategory from '../../api/hooks/useCategory';
import useToggle from '../../hooks/useToggle';
import { toIcons } from '../../consts/Paths';
import { useForm } from 'react-hook-form';
import DeleteModal from '../modals/DeleteModal';
import useOffer from '../../api/hooks/useOffers';
import Loader from '../Loader';
import { Checkbox } from '@mui/material';
import { apiURL } from '../../consts/URLs';

const Sites = (props: any) => {
    const { isMobile } = useIsMobile();

    const { isToggled } = props.resetList;

    const { user, userTreated, token } = useContext(MainContext);

    const { RESPONSES, RESULTS, CTAs } = useOffer();

    const [defaultSites, setDefaultSites] =useState<string>("");


    
    const [sites, setSites] = useState<{ name: string; id: number }[]>([]);

    useEffect(()=>{
        updateDefaultSites();
    },[]);

    const updateDefaultSites = () =>{
        const endpoint = `${apiURL}/settings/get_default_sites`;
        
        /**
         * GIANLUCA BIANCHI: ENABLE ONLY FOR DEV TESTING, NO PROD ENABLED
         */
        //alert(endpoint);
        const header = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8',
            },
        };
        
        fetch(endpoint, header)
        .then(response => response.json())
        .then(data => setDefaultSites(data.default_sites))
    }

    const changeDefaultSites= (site_id:number, default_site:boolean) =>{

        const endpoint = `${apiURL}/settings/set_default_sites?id=${site_id}&is_default=${default_site===true ? 1 :0 }`;
        
        const header = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8',
            },
        };
        
        fetch(endpoint, header)
        .then(response =>{
            if(response.ok){
                console.log("site update succesfully!");
            }
            updateDefaultSites();
        });
      
    }

    useEffect(() => {
        CTAs.getSites();
    }, [isToggled, user, userTreated, RESPONSES.removeSiteResponse]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSES.getSitesResponse?.ok) {
            console.log(RESULTS.getSitesResult);
            setSites(
                RESULTS.getSitesResult.map((item: any) => ({
                    id: item.id,
                    name: item.site,
                }))
            );
        }
    }, [RESPONSES.getSitesResponse]);

    const renderSites = sites.map((site, key) => { 
        return (
            <div key={key} className='user-card'>
                <p style={{ fontFamily: 'Roboto' }}>{site.name}</p>
                <Checkbox title='default' style={{height:'30px', paddingLeft:'80px'}} checked={defaultSites.includes(site.name) ? true : false} onChange={(e)=> changeDefaultSites(site.id, e.currentTarget.checked)}  />


                {/* <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={() => handelOnDeleteClick(site.id)}
                /> */}
            </div>
        );
    });

    return (
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
            <div
                className='user-table-header'
                style={{
                    justifyContent: isMobile ? 'space-between' : '',
                    margin: '31px 25px',
                }}
            >
                <div className='user-table-header-title-box'>
                    <p className='user-table-header-title'>Siti</p>
                    <p className='user-table-header-description'>Manage sites</p>
                </div>
                <button className='user-table-header-button shadow' type='button' onClick={props.toggler.toggle}>
                    <p className='user-table-header-button-text'>Add site</p>
                </button>
            </div>
            <div className='user-table-content'>
                <div className='offers-table'>
                    <div className='offers-table-fields'>
                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                            }}
                        >
                            <p className='field-label'>Name</p>
                        </div>
                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginLeft: '40px'
                            }}
                        >
                            <p className='field-label'>Default</p>
                        </div>
                        <div
                            className='u-mail'
                            style={{
                                margin: isMobile ? '0' : '',
                            }}
                        >
                            {/* <p className='field-label'>Id</p> */}
                        </div>
                        {!isMobile && (
                            <div className='u-mail'>
                                <p className='field-label'></p>
                            </div>
                        )}
                        <div
                            className='u-status'
                            style={{
                                marginLeft: isMobile ? '135px' : '',
                            }}
                        >
                            <p className='field-label'></p>
                        </div>
                    </div>
                    <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
                    <form >
                    {sites.length > 0 ? <div className='users-table-results scroll-y'>{renderSites}</div> : <Loader />}
                    </form>
                </div>
            </div>
        </div>
    );
};
export default Sites;
